import { render } from "./NotifyList.vue?vue&type=template&id=905b3fbe"
import script from "./NotifyList.vue?vue&type=script&lang=js"
export * from "./NotifyList.vue?vue&type=script&lang=js"

import "./NotifyList.vue?vue&type=style&index=0&id=905b3fbe&lang=css"

import exportComponent from "E:\\OpenServer\\domains\\vue\\vue-catalog\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__